import axios from "axios";
import Cookies from "js-cookie";

export const addModel = ({ requestPayload, userEmail }) =>
  axios
    .post(
      `${process.env.REACT_APP_API_GATEWAY}/level/v2/portfolioBuilder`,
      requestPayload,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response?.data);

export const addModelByTemplate = ({ requestPayload, templateId, userEmail }) =>
  axios
    .post(
      `${process.env.REACT_APP_API_GATEWAY}/level/v2/portfolioBuilder/byModel/${templateId}`,
      requestPayload,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response?.data);

export const addWealthAdvisor = ({ requestBody, userEmail }) =>
  axios.post(`${process.env.REACT_APP_API_GATEWAY}/user`, requestBody, {
    headers: {
      Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
    },
  });

export const archiveWealthManager = ({ clientEmail, userEmail }) =>
  axios.patch(
    `${process.env.REACT_APP_API_GATEWAY}/user/archive?email=${clientEmail}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const deleteModel = ({ modelId, userEmail }) =>
  axios.delete(
    `${process.env.REACT_APP_API_GATEWAY}/level/v2/portfolioBuilder/${modelId}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const duplicateModel = ({ modelId, requestPayload, userEmail }) =>
  axios
    .post(
      `${process.env.REACT_APP_API_GATEWAY}/level/v2/portfolioBuilder/duplicate/${modelId}`,
      requestPayload,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response?.data);

export const getTemplateList = ({ organization, userEmail }) =>
  axios
    .get(
      `${process.env.REACT_APP_API_GATEWAY}/level/v2/portfolioBuilder/templates?organization=${organization}`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response?.data);

export const impersonateUser = ({ clientEmail, userEmail }) =>
  axios
    .post(
      `${process.env.REACT_APP_API_GATEWAY}/auth/v2/impersonate`,
      {
        email: clientEmail,
      },
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response?.data);

export const getModelsSaved = ({ userEmail }) =>
  axios
    .get(
      `${process.env.REACT_APP_API_GATEWAY}/level/v2/portfolioBuilder/user-models`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response?.data);

export const getModelCalculation = ({ holdings, userEmail, code, name }) =>
  axios
    .post(
      `${process.env.REACT_APP_FASTAPI}/level/modelBuilder/calculate`,
      {
        Structure: holdings,
        Code: code,
        Name: name,
      },
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response?.data);

export const getModelsSelected = ({ organization, userEmail }) =>
  axios
    .get(
      `${process.env.REACT_APP_API_GATEWAY}/level/v2/portfolioBuilder/selected?organization=${organization}`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(
      response =>
        Array.isArray(response?.data) &&
        response.data.filter(it => !it.isArchived)
    );

export const getWealthAdvisorData = ({ clientEmail, userEmail }) =>
  axios
    .get(
      `${process.env.REACT_APP_API_GATEWAY}/user/advisor?email=${encodeURIComponent(clientEmail)}`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response?.data);

export const updateBuilderWelcomeModalVisibilityAdmin = ({ userEmail }) =>
  axios.put(
    `${process.env.REACT_APP_API_GATEWAY}/level/orgManager/profileSettings/notificationWelcome`,
    { set: true },
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const updateCompanySettingsByJwt = ({ requestPayload, userEmail }) =>
  axios
    .patch(
      `${process.env.REACT_APP_API_GATEWAY}/company/settings`,
      requestPayload,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response?.data);

export const updateCompanyUserByWealthAdmin = ({
  companyUserEmail,
  requestPayload,
  userEmail,
}) =>
  axios.patch(
    `${process.env.REACT_APP_API_GATEWAY}/user/info?email=${encodeURIComponent(companyUserEmail)}`,
    requestPayload,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const updateModel = ({ modelId, requestPayload, userEmail }) =>
  axios.put(
    `${process.env.REACT_APP_API_GATEWAY}/level/v2/portfolioBuilder/${modelId}`,
    requestPayload,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const updateFavoriteProductsWealthAdmin = ({ requestBody, userEmail }) =>
  axios.put(
    `${process.env.REACT_APP_API_GATEWAY}/level/orgManager/profileSettings/favoriteProducts`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const updateHoldingColumnOrderWealthAdmin = ({
  requestBody,
  userEmail,
}) =>
  axios.put(
    `${process.env.REACT_APP_API_GATEWAY}/level/orgManager/profileSettings/tableHoldingsColumnsOrder`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const updateWealthAdvisor = ({ requestBody, userEmail }) =>
  axios.patch(
    `${process.env.REACT_APP_API_GATEWAY}/user/info?email=${requestBody.email}`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const updateEnabledInvestmentsForAdvisor = ({
  requestPayload,
  userEmail,
}) =>
  axios
    .patch(
      `${process.env.REACT_APP_API_GATEWAY}/company/advisors/products`,
      requestPayload,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
        },
      }
    )
    .then(response => response?.data?.advisorProducts);

export const uploadCompanyLogoByJwt = ({ requestPayload, userEmail }) =>
  axios
    .post(`${process.env.REACT_APP_API_GATEWAY}/company/logo`, requestPayload, {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    })
    .then(response => response?.data);
